import type { StisFilterValues } from './stis-inline-filters';

// Every key the panel can set. One left out comes back half restored: a VIN's year and carline
// without the VIN that locked them is a different filter.
const FILTER_KEYS = [
    'publicationTypes',
    'carline',
    'modelYear',
    'trim',
    'vin',
    'publishedYear',
    'publishedMonth',
] as const;

const KEY_PREFIX = 'stis-publications-filters:';

const storageKey = (pathname: string) => `${KEY_PREFIX}${pathname}`;

// An empty array reads as an active filter to the list page, so it is dropped too
const pickFilters = (filters: Record<string, unknown> | null | undefined): Partial<StisFilterValues> => {
    const picked: Record<string, unknown> = {};
    for (const key of FILTER_KEYS) {
        const value = filters?.[key];
        if (Array.isArray(value) ? value.length > 0 : Boolean(value)) {
            picked[key] = value;
        }
    }
    return picked as Partial<StisFilterValues>;
};

export const loadListFilters = (pathname: string): Partial<StisFilterValues> => {
    try {
        const raw = sessionStorage.getItem(storageKey(pathname));
        return raw ? pickFilters(JSON.parse(raw)) : {};
    } catch {
        return {};
    }
};

export const saveListFilters = (pathname: string, filters: Record<string, unknown>) => {
    try {
        const picked = pickFilters(filters);
        if (Object.keys(picked).length === 0) {
            sessionStorage.removeItem(storageKey(pathname));
        } else {
            sessionStorage.setItem(storageKey(pathname), JSON.stringify(picked));
        }
    } catch {
        // Storage can be full or blocked; the filters then last only for this visit
    }
};

export const isStisFilterPath = (pathname: string): boolean => {
    if (pathname.startsWith('/stis/service-diagnostics')) {
        return false;
    }
    return (
        pathname === '/stis' ||
        pathname.startsWith('/stis/') ||
        /^\/vin\/[^/]+\/stis(\/|$)/.test(pathname) ||
        pathname.startsWith('/administration/publications') ||
        pathname.startsWith('/administration/publication/')
    );
};

export const clearListFilters = () => {
    try {
        const keys = Object.keys(sessionStorage).filter((key) => key.startsWith(KEY_PREFIX));
        keys.forEach((key) => sessionStorage.removeItem(key));
    } catch {}
};
